import {TelemedicineEnum} from 'presentation/pages/private/booking/constants';
import {HistoryFilterEnum} from 'presentation/modules/myAppointments/constants/historyFilterEnum';
import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';

type Params = {
	typeAttendance: TypeAttendance;
	telemedicine: TelemedicineEnum;
};

export function getAppointmentHistoryBookingType({telemedicine, typeAttendance}: Params) {
	if (typeAttendance === TypeAttendance.EMERGENCY) {
		return HistoryFilterEnum.EMERGENCY;
	}

	if (typeAttendance === TypeAttendance.SURGERY) {
		return HistoryFilterEnum.SURGERY;
	}

	if (telemedicine === TelemedicineEnum.IS_TELEMEDICINE) {
		return HistoryFilterEnum.TELEHEALTH;
	}

	return HistoryFilterEnum.HEALTH;
}
